import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import {
  trigger,
  style,
  animate,
  transition,
  query,
  stagger,
  keyframes,
  state,
  group,
} from "@angular/animations";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import {StoreService} from '../store.service';

declare var $: any;

@Component({
  selector: "app-case-practice-report-new-2",
  animations: [
    trigger("analysisBoxAnimation", [
      state(
        "hideAnalysisBox",
        style({ opacity: 0, transform: "translate(-100%)" })
      ),
      state("showAnalysisBox", style({ opacity: 1 })),
      transition(
        "hideAnalysisBox => showAnalysisBox",
        animate(
          "200ms",
          keyframes([
            style({
              transform:
                "matrix3d(0.08700000000000001,-0.09,0.50,0,0.09,0.01,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "45%",
            }),
            style({
              transform:
                "matrix3d(0.43065,-0.12,0.50,0,0.12,0.2475,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "47%",
            }),
            style({
              transform:
                "matrix3d(0.6525,-0.07,0.50,0,0.07,0.6,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "49%",
            }),
            style({
              transform:
                "matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,0,0,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "50%",
            }),
          ])
        )
      ),
      transition(
        "showAnalysisBox => hideAnalysisBox",
        animate(
          "500ms",
          keyframes([style({ opacity: 1 }), style({ opacity: 0 })])
        )
      ),
    ]),
    trigger("starAnimation", [
      state("hideStar", style({ opacity: 0 })),
      state("showStar", style({ opacity: 1 })),
      transition("hideStar => showStar", [
        style({ opacity: 1 }),
        query(".starReport", style({ opacity: 0 })),
        query(".starReport5", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport4", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport3", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport2", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport1", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
      ]),
    ]),
  ],
  templateUrl: "./case-practice-report-new-2.component.html",
  styleUrls: [
    "./case-practice-report-new-2.component.css"
  ],
})
export class CasePracticeReportNew2Component implements OnInit, AfterViewInit {
  currentName: any;
  currentTotal: any;
  currentDescription: any;
  currentAnalysis: any;

  practiceId: any;
  exerciseId: any;
  learningPathId: any;

  report: any;

  //报告等级KA对象：传递给等级组件
  reportKAData: any;
  // 是否显示等级组件：用于异步渲染判断
  isShowReportLv: boolean;
  //二级标识，用于判断接口返回正常不正常：正常显示组件，不正常隐藏组件
  targetShow: any;

  // chuanjie: any;
  learningPathMetaId: any;
  learningPath: any;
  learningTour: any;
  finished: boolean;
  practiceMetaId: number;
  analysisBoxShow: boolean;
  starShow: boolean;
  reportName: string;

  tutor: any;
  optimum: any;

  mode: number;
  lvCls: string;

  starPicUrl: string;

  pathClickable: boolean;

  itemClickEnable: boolean = false;
  assetsRoute: string = "../../assets";
  type : string
  constructor(
    private commonService: CommonService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private storeService:StoreService
  ) {}

  ngOnInit() {
    let that = this;
    this.isShowReportLv = false;
    this.route.queryParams.subscribe(queryParams=>{
        this.type=queryParams['type']
    })
    this.route.params.subscribe((params) => {
      this.practiceId = params["practiceId"];
      this.exerciseId = params["exerciseId"];
      this.learningPathId = params["learningPathId"];

      //practiceId = 9898  决策
      this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
      this.apiService
        .ajax({
          type: "get",
          url: "/wx/api/report/" + this.practiceId,
        })
        .subscribe((result) => {
          this.practiceMetaId = result.practiceMetaId;
          this.report = result.reports[0].kas;
          if (this.report.length == 0) {
            this.redo();
            // return false;
          }else{
            this.reportName = result.reports[0].name;
            this.finished = result.allExerciseFinished;
            $.ajax({
              url: "/sr/insideapi/getlevel",
              type: "post",
              dataType: "json",
              contentType: "application/json;charset=utf-8",
              data: JSON.stringify(this.getKaList(result.reports[0])),
              async: false,
              headers : {
                'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
                'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
              },
              success: function (result) {
                if (result && result != "") {
                  that.reportKAData = result;
                  that.targetShow = 1;
                } else {
                  that.targetShow = 0;
                }
              },
              error: function (er) {
                that.targetShow = 0;
                if(er.status === 401 && Number(er.responseJSON.code) === 106){
                  that.storeService.notification.notAuthed.next(true);
                }
              },
            });

            if (result.reports[0].name == "组织与计划") {
              this.mode = 2;
              if (that.targetShow == 0) {
                this.lvCls = this.mode + "";
              } else {
                this.lvCls = this.mode + " bgBlur";
              }
              this.starPicUrl = "/casepracticepando/star2.png";
            } else {
              this.mode = 1;
              if (that.targetShow == 0) {
                this.lvCls = this.mode + "";
              } else {
                this.lvCls = this.mode + " bgBlur";
              }
              this.starPicUrl = "/casepracticeteam/star_report.png";
            }

            if (that.targetShow === 0) {
              this.isShowReportLv = false;
            } else {
              this.isShowReportLv = true;
            }
            setTimeout(() => {
              this.itemClickEnable = true;
            }, 500);
          }

          // //对象赋值并显示等级组件
          // this.reportKAData = this.getKaList(result.reports[0]);
          // this.isShowReportLv = true;
        });
      this.apiService
        .ajax({
          type: "get",
          url: "/wx/api/tutor/8",
        })
        .subscribe((result) => {
          this.tutor = result.tutor;
          this.optimum = result.optimum;
        });

      this.apiService
        .ajax({
          type: "get",
          url: "/sr/learningtour",
        })
        .subscribe((result) => {
          this.learningTour = result;
        });
    });
    this.analysisBoxShow = false;
    this.starShow = false;
    this.pathClickable = true;
  }

  ngAfterViewInit() {
    //修改层的 left
    setTimeout(function () {
      $("#shade").css("left", "0");
    }, 1000);

    this.commonService.initPage({
      backgroundColor: "white",
    });
  }

  /*
  格式化KA对象方法
   report：传递一个报告对象
 */
  getKaList(report) {
    let kaJson = {
      id: report.id,
      name: report.name,
      type: report.type,
      kas: {},
      exercisesId: this.exerciseId,
      questionId: null,
      optionId: null,
    };
    if (report) {
      for (let i = 0; i < report.kas.length; i++) {
        let kaItem = report.kas[i];
        if (kaItem) {
          //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
          kaJson.kas[kaItem.name] = kaItem.value;
        }
      }
    }
    return kaJson;
  }

  close() {
    if (this.reportName == "授权") {
      let link = [
        this.learningPathId,
        this.practiceMetaId,
        "case-practice-authorization",
      ];
      if(this.type){
        this.router.navigate(link,{queryParams:{type:'huatek'}});
      }else{
        this.router.navigate(link);
      }
    } else if (this.reportName == "决策") {
      this.apiService
        .ajax({
          type: "get",
          url: "/sr/learningtour",
        })
        .subscribe((result) => {
          this.learningTour = result;
          // if (this.learningTour.learning_path_metas[0].id == 16){
          //     this.learningPathId = this.learningTour.learning_path_metas[0].learningPathId;
          //     let link = [this.learningPathId, 10,'case-practice-influence'];
          //     this.router.navigate(link);
          //
          // }
          for (
            let i = 0, len = this.learningTour.learning_path_metas.length;
            i < len;
            i += 1
          ) {
            if (this.learningTour.learning_path_metas[i].id == 16) {
              this.learningPathId = this.learningTour.learning_path_metas[
                i
              ].learningPathId;
              let link = [this.learningPathId, 10, "case-practice-influence"];
              if(this.type){
                this.router.navigate(link,{queryParams:{type:'huatek'}});
              }else{
                this.router.navigate(link);
              }
            }
          }
        });

      //let link = [this.learningPathId, 10,'case-practice-influence'];
      //this.router.navigate(link);
    } else {
      let link = [this.learningPathId, this.practiceMetaId, "case-practice"];
      if(this.type){
        this.router.navigate(link,{queryParams:{type:'huatek'}});
      }else{
        this.router.navigate(link);
      }
    }
  }

  subWrapOneOut() {
    $("#subWrapOne").fadeOut(function () {
      $("#subWrapTwo").fadeIn();
      $("#btnWrap").fadeIn();
    });
  }

  tourReviewBoxIn() {
    $("#tourReviewShade").fadeIn();
    $("#tourReviewBox").fadeIn();
    $("#closeBtn1").fadeIn();
    this.pathClickable = false;
  }

  tourReviewBoxOut() {
    $("#tourReviewShade").fadeOut();
    $("#tourReviewBox").fadeOut();
    $("#closeBtn1").fadeOut();
    this.pathClickable = true;
  }

  bestPathIn() {
    if (!this.pathClickable) {
      return;
    }
    $("#bestPathBox").fadeIn();
    $("#closeBtn2").fadeIn();
    $("#shade").fadeIn();
  }

  bestPathOut() {
    $("#bestPathBox").fadeOut();
    $("#closeBtn2").fadeOut();
    $("#shade").fadeOut();
  }

  redo() {
    var _this = this;
    this.apiService
      .ajax({
        type: "get",
        url: "/wx/api/resetpid/" + this.practiceId,
      })
      .subscribe((result) => {
        setTimeout(function () {
          let link = [
            "case-practice-hotel",
            _this.practiceId,
            _this.exerciseId,
            _this.learningPathId,
          ];
          if(_this.type){
             _this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
             _this.router.navigate(link);
          }
        }, 50);

        //this.tutor = result.tutor;
        //this.optimum = result.optimum;
      });
  }

  analysisBoxIn(i) {
    if (!this.itemClickEnable) {
      return false;
    }
    let _this = this;
    this.currentName = this.report[i].name;
    this.currentDescription = this.report[i].description;
    this.currentTotal = this.report[i].value;
    this.currentAnalysis = this.report[i].analysis;
    $("#analysisShade").fadeIn();
    // 滚动到订端
    $("#analysisContent").scrollTop(0);
    // $('#analysisBox').fadeIn();
    this.analysisBoxShow = true;
    $("subWrapTwo").css({ oveflow: "hidden" });
    setTimeout(function () {
      _this.starShow = true;
    }, 300);

    this.pathClickable = false;
  }

  analysisBoxOut() {
    $("#analysisShade").fadeOut();
    this.analysisBoxShow = false;
    $("subWrapTwo").css({ oveflow: "scroll" });
    this.starShow = false;
    this.pathClickable = true;
  }

  goToList() {
    this.apiService
      .ajax({
        type: "get",
        url: "/sr/learningtour",
      })
      .subscribe((result) => {
        this.learningTour = result;
        // console.log(this.learningTour.learning_path_metas[0].id);
        for (
          let i = 0, len = this.learningTour.learning_path_metas.length;
          i < len;
          i += 1
        ) {
          if (this.learningTour.learning_path_metas[i].id == 16) {
            this.learningPathId = this.learningTour.learning_path_metas[
              i
            ].learningPathId;
            let link = [this.learningPathId, 10, "case-practice-influence"];
            if(this.type){
              this.router.navigate(link,{queryParams:{type:'huatek'}});
            }else{
              this.router.navigate(link);
            }
          }
        }
        // if (this.learningTour.learning_path_metas[0].id == 16){
        //     this.learningPathId = this.learningTour.learning_path_metas[0].learningPathId;
        //     let link = [this.learningPathId, 10,'case-practice-influence'];
        //     this.router.navigate(link);
        // }
      });
  }

  linkToPostSurvey() {
    this.apiService
      .ajax({
        type: "get",
        url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
      })
      .subscribe((result) => {
        this.learningPathMetaId = result.data;
        this.apiService
          .getOrCreateLearningPath(this.learningPathMetaId)
          .subscribe((result) => {
            this.learningPath = result;
            if (this.learningPath.subItems.length == 3) {
              this.apiService
                .ajax({
                  type: "get",
                  url: "/sr/learningtour",
                })
                .subscribe((result) => {
                  this.learningTour = result;
                  let link = ["survey", this.learningTour.tour_id, 3, 2];
                  this.router.navigate(link);
                });
            } else {
              let link = [
                "survey",
                this.learningPath.id,
                this.learningPath.subItems[4].surveyMetaId,
                1,
              ];
              this.router.navigate(link);
            }
          });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-report-new-2/case-practice-report-new-2.component.ts